<template>
  <responsive-modal v-model="visible" title="Integrar Zapier">
    <div class="tool-modal-zapier">
      <a href="https://zapier.com/" target="_blank" class="integration-link">
        Conheça a Zapier
        <i class="ph ph-arrow-square-out" />
      </a>
      <snow-select
        :disabled="form.id != null"
        id="product-select"
        label="Produto"
        v-model="form.product_id"
        :errors="errors.product_id"
        :options="products.map(({ id, name }) => ({ id, name }))"
      />
      <snow-input
        label="Descrição da integração (Opcional)"
        id="description"
        v-model="form.description"
      />
      <snow-input label="URL" id="url" v-model="form.url" :rules="rules.url" />
      <action-dispatcher action="integration/getTypeEvents">
        <snow-checkboxes-dropdown
          label="Eventos disparados"
          id="events-select"
          v-model="form.events"
          :options="normalizedTypeEvents"
        />
      </action-dispatcher>

      <div class="snow-submit-buttons">
        <snow-button
          size="lg"
          text="Cancelar"
          variant="gray"
          class="order-lg-0 order-1"
          @click="
            visible = false;
            clear();
          "
        />
        <snow-button
          size="lg"
          text="Salvar"
          :disabled="!isValid"
          :loading="loading"
          @click="submit"
        />
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";
import { required, validUrl } from "@/functions/validation";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(
        [
          "product_id",
          "url",
          "status",
          "description",
          "events",
          "extras",
          "name"
        ],
        {
          events: [],
          name: "zapier",
          extras: { is_json: true }
        }
      ),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
        this.form.events = v.events.map(e => e.event);
        this.form.product_id = v.events[0].product_id;
        this.form.extras = v.extras || { is_json: true };
      }
    }
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch("product/get", { limit: 500 })
      .then()
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("integration", ["typeEvents"]),
    isValid() {
      return this.form.product_id && this.form.events.length && this.form.url;
    },
    normalizedTypeEvents() {
      return this.typeEvents.map(e => ({
        id: e.id,
        label: e.name
      }));
    },
    rules() {
      return {
        url: [required(), validUrl()]
      };
    }
  },
  methods: {
    clear() {
      this.form = {
        name: "zapier",
        events: [],
        extras: { is_json: true }
      };
      this.$emit("clear-edit");
    },
    submit() {
      if (this.loading) return;

      this.loading = true;
      let data = { ...this.form };

      // if (
      //   data.url.indexOf("https://") == -1 ||
      //   data.url.indexOf(".com") == -1
      // ) {
      //   this.$message.warning("Digite uma url válida");
      //   this.errors = {
      //     ...this.errors,
      //     url: ["Digite uma url válida"]
      //   };
      //   return;
      // }

      data.events = data.events.map(e => ({ event: e }));

      let action = "integration/postIntegration";
      if (this.integrationToEdit) {
        data.id = this.integrationToEdit.id;
        action = "integration/putIntegration";
      }
      this.$store
        .dispatch(action, data)
        .then(() => {
          this.visible = false;
          this.$emit("update-list");
          this.clear();
          this.$message.success("A integração foi salva!");
        })
        .catch(e =>
          this.handleErrors(
            e,
            "TRANSLATE_FIELD_INTEGRATION_MAP",
            "Erro ao salvar configuração"
          )
        )
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-zapier {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
